export default __webpack_public_path__ + "static/media/thumbdown.4f45a3c9.svg";